import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import OutImgSection from "../out-img-section";
import { colors, safeSpacing } from "@/utils/const";
import CustomText from "../text";
import { useI18n } from "@/i18n/I18nProvider";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export default function PgWithImgSection({
  img,
  title,
  titleType,
  paragraph,
  paragraphType,
  imgReverse,
  isPreLine,
}) {
  const { locale } = useI18n();
  const isArabic = locale === "ar";

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "xl"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));

  const horizontal = (() => {
    if (isXs) return safeSpacing.horizontal.xs;
    if (isSm) return safeSpacing.horizontal.sm;
    if (isMd) return safeSpacing.horizontal.md;
    if (isLg) return safeSpacing.horizontal.lg;
    if (isXl) return safeSpacing.horizontal.xl;
    return safeSpacing.horizontal;
  })();
  const cleanText = (text) =>
    typeof text === "string"
      ? text.replace(/&lt;/g, "<").replace(/&gt;/g, ">")
      : text;
  return (
    <Box
      data-aos={"fade-down"}
      data-aos-delay={"500"}
      sx={{ bgcolor: colors.navy, overflowX: "hidden" }}
    >
      <Box
        component="section"
        className="horizontal-safe-padding vertical-safe-padding"
        sx={{ overflow: "hidden" }}
      >
        <Grid
          container
          spacing={{ xs: 4, md: 2, xl: 8 }}
          alignItems="center"
          sx={{
            position: "relative",
            zIndex: 1,
            flexDirection: {
              // xs: "column-reverse",
              xs: "column",
              md: "row",
              // md: reverse ? "row-reverse" : "row",
            },
          }}
        >
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              position: "relative",
              display: "flex",
              order: { xs: 1, md: imgReverse ? 2 : 1 },
              justifyContent: {
                xs: "center",
                md: !isArabic ? "flex-start" : "flex-end",
              },
              // pl: 0 ,
            }}
          >
            <OutImgSection
              img={img}
              altImg={title}
              customStyle={{
                width: "100%",
                ...(isArabic
                  ? {
                      marginRight: {
                        xs: 0,
                        md: imgReverse ? `${horizontal}px` : 0,
                      },
                    }
                  : {
                      marginLeft: {
                        xs: 0,
                        md: imgReverse ? `${horizontal}px` : 0,
                      },
                    }),
                zIndex: 1,
                transform: {
                  lg: isArabic
                    ? imgReverse
                      ? "translateX(-15%)"
                      : "translateX(15%)"
                    : imgReverse
                      ? "translateX(20%)"
                      : "translateX(-20%)",

                  xl: "translateX(0%)",
                },
              }}
              side={isArabic ? "right" : "left"}
              imgReverse={imgReverse}
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={8}
            sx={{
              order: { xs: 2, md: imgReverse ? 1 : 2 },
            }}
          >
            <CustomText
              text={title}
              type="xl"
              customStyle={{
                color: colors.dark_yellow,
                fontWeight: "700",
                lineHeight: 1,
                ...(isPreLine && {
                  maxWidth: {
                    xs: "100%",
                    lg: "500px",
                  },
                }),
              }}
              variant={titleType || "h2"}
            />
            {paragraph && (
              <CustomText
                text={paragraph}
                type="xs"
                customStyle={{
                  color: colors.white,
                  lineHeight: "24px",
                  mt: { xs: 2, md: 4 },

                  fontWeight: "300",
                  whiteSpace: "pre-wrap",
                  "& a": {
                    color: `${colors.white} !important`,
                    textDecorationColor: `${colors.white} !important`,
                  },
                }}
                variant={paragraphType}
                enableHtml={true}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
